module.exports = __webpack_public_path__ + "static/img/FSHOW.c4ef37cc.png";